<template>
  <div class="details-view">
    <cargo-left-right-resize
      v-show="Boolean(action)"
      ref="cargoLeftRightResize"
      :left-style="{flex:'none','max-width':'220px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template v-show="action==='look'" slot="left">
        <div style="min-width: 180px;width:100%;height:100%;padding:10px 0px 10px;">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="gridOptions"
            :column-defs="gridOptions.columnDefs"
            :row-data="rowData"
            style="width:100%;height:100%;min-height: 500px;padding-left: 16px;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers" style="flex:none">
              <cargo-button-group-slider>
                <div v-show="action==='look'">
                  <!--返回-->
                  <el-button no="back" type="primary" @click="goBack">{{ $t('common.btn.back') }}</el-button>
                  <!--编辑-->
                  <el-button v-if="!isVerify" no="edit" type="success" @click="editHandler()">{{ $t('SeaExport.Edit') }}</el-button>
                  <!--复制-->
                  <el-button v-if="isOrder && $checkPermission(['button_FBAOrder_newFbaBookingOrders'])" no="Clone" type="primary" @click="toCopy()">{{ $t('SeaExport.Clone') }}</el-button>
                  <!--暂不提交-->
                  <el-button v-if="isOrder && currentRow.submitState === 2 && (currentRow.verifyState === 0 || currentRow.verifyState === 2 || currentRow.verifyState === 6) && $checkPermission(['button_FBAOrder_notSubmitFbaBookingOrder'])" no="notSubmit" type="primary" @click="toNotSubmit()">{{ $t('CargoMsg.Cargo_HoldSubmission') }}</el-button>
                  <!--提交-->
                  <el-button v-if="isOrder && currentRow.submitState === 1 && $checkPermission(['button_FBAOrder_submitFbaBookingOrder'])" no="submit" type="primary" @click="toSubmit()">{{ $t('CargoMsg.Cargo_Submit') }}</el-button><!--提交-->
                  <!--打印-->
                  <el-button v-if="$checkPermission(['button_FBAOrder_printFbaBookingOrder'])" no="print" type="success" @click="onPrint">{{ $t('SeaExport.print') }}</el-button>
                  <!--审核通过-->
                  <el-button v-if="isVerify && $checkPermission(['button_FBAVerify_acceptFbaBookingOrder'])" no="approved" type="primary" :disabled="Number(currentRow.verifyState) !== 0" @click="toApproved()">{{ $t('SeaExport.PassAudit') }}</el-button>
                  <!--审核拒绝-->
                  <el-button v-if="isVerify && $checkPermission(['button_FBAVerify_rejectFbaBookingOrder'])" no="refuse" type="primary" :disabled="Number(currentRow.verifyState) !== 0" @click="toRefuse()">{{ $t('SeaExport.Refuse') }}</el-button>
                  <!--复核通过-->
                  <el-button v-if="isVerify && isPretrialReviewFBA && $checkPermission(['button_FBAVerify_reviewThroughFbaBookingOrder'])" no="reApproved" type="primary" :disabled="Number(currentRow.verifyState) !== 1" @click="toReApproved()">{{ $t('SeaExport.VerifyReviewThrough') }}</el-button>
                  <!--复核拒绝-->
                  <el-button v-if="isVerify && isPretrialReviewFBA && $checkPermission(['button_FBAVerify_reviewRefusalFbaBookingOrder'])" no="reRefuse" type="primary" :disabled="Number(currentRow.verifyState) !== 1" @click="toReRefuse()">{{ $t('SeaExport.VerifyReviewRefusal') }}</el-button>
                  <img
                    v-show="preVerifyStateIcon"
                    :src="preVerifyStateIcon"
                    width="100"
                    height="99"
                    style="position: fixed;z-index: 99;right: 25%;margin: -10px 0 0 0;"
                  >
                </div>
                <div v-show="(isNew || action==='edit')" class="new" style="border-left:none;padding-left:0">
                  <el-button no="save" type="success" @click="saveHandler">{{ $t('common.btn.save') }}</el-button>
                  <el-button no="cancel" type="success" @click="cancelEdit()">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="SaveTheDefaultValues2" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
              </cargo-button-group-slider>
            </div>
          </div>
          <div class="tabs-container" style="position: relative">
            <el-tabs ref="tabs" v-model="activeTabName" type="card" style="width:100%" @tab-click="handleTabClick">
              <el-tab-pane :label="$t('SeaExport.Consignation')" :lazy="true" name="tabBaseInfo">
                <tab-order-info ref="tabBaseInfo" :context="parentContext" :action="action" :view-source="viewSource" @onRefresh="onRefresh" />
              </el-tab-pane>
              <el-tab-pane :label="$t('SeaExport.Charge')" :lazy="true" name="tabCharges">
                <tab-charges ref="tabCharges" :context="parentContext" :action="action" :view-source="viewSource" />
              </el-tab-pane>
              <el-tab-pane v-if="!isNew && currentRow.uuid" :label="$t('SeaExport.FileHistory')" :lazy="true" name="tabFileHistory">
                <tab-file-history ref="tabFileHistory" :context="parentContext" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      ref="templateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="parentContext"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />

    <!--    订舱审核-通过   -->
    <fba-op-verify-frame-dialog
      v-if="opVerifyFrameDialog.visible"
      :visible.sync="opVerifyFrameDialog.visible"
      :job-model="opVerifyFrameDialog.job || {}"
      :submit-call-back="opVerifyFrameDialog.submitCallBack"
    />
    <!--    订舱审核-拒绝   -->
    <op-verify-frame-reject
      v-if="rejectWindow.visible"
      :visible.sync="rejectWindow.visible"
      :job-no="rejectWindow.jobNo"
      type="fba"
      :reject-call-back="rejectWindow.rejectCallBack"
    />
  </div>
</template>

<script>
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import tabOrderInfo from '../Order/tabOrderInfo'
import { ensureExecuteSuccess, sleep } from '@/utils/commonUtil'
import tabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { saveFbaJob, getFbaJob, saveCopyJob, updNotSubmitOrSubmit, approved } from '@/api/Fba/fbaJob'
import { TabError } from '@/utils/class/TabError'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import icon1 from '@/assets/remote-booking/icon-1.png'
import icon2 from '@/assets/remote-booking/icon-2.png'
import icon3 from '@/assets/remote-booking/icon-3.png'
import icon4 from '@/assets/remote-booking/icon-4.png'
import icon5 from '@/assets/remote-booking/icon-5.png'
import icon6 from '@/assets/remote-booking/icon-6.png'
import iconEn1 from '@/assets/remote-booking/icon-en-1.png'
import iconEn2 from '@/assets/remote-booking/icon-en-2.png'
import iconEn3 from '@/assets/remote-booking/icon-en-3.png'
import iconEn4 from '@/assets/remote-booking/icon-en-4.png'
import iconEn5 from '@/assets/remote-booking/icon-en-5.png'
import iconEn6 from '@/assets/remote-booking/icon-en-6.png'
import { FbaJob } from '@/class/model/booking/FbaJob'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { cache, cacheName } from '@/utils/cacheManager'
import { deepClone } from '@/utils'
import FbaOpVerifyFrameDialog from '@/views/cargo/v0/FBA/FbaOpVerifyFrameDialog'
import OpVerifyFrameReject from '@/views/cargo/v0/SeaExport/components/verify/OpVerifyFrameReject'

export default {
  name: 'OrderWorkspace',
  components: { OpVerifyFrameReject, FbaOpVerifyFrameDialog, cargoTemplateSelectorDialog, tabFileHistory, cargoLeftRightResize, CargoButtonGroupSlider, tabOrderInfo, tabCharges },
  props: {
    parentContext: { type: Object, required: true },
    viewSource: { type: String, default: 'fbaOrder' } // 引用页面: fbaVerify=订单审核
  },
  data() {
    return {
      action: 'edit',
      copyJobNum: 0,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        columnDefs: [
          { headerName: this.$t('FbaJob.BookingNo'), field: 'bookingNo', minWidth: 160, colId: 'bookingNo' }
        ],
        onRowClicked: this.onRowClicked
      },
      rowData: [],
      gridApi: null,
      currentRow: {},
      activeTabName: 'tabBaseInfo',
      pendTabSet: new Set(),
      form: {

      },
      loading: false,
      templateSelectorDialog: {
        visible: false,
        ctx: new FbaJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      isPretrialReviewFBA: false, // 是否开启复核
      rejectWindow: { // 拒绝
        visible: false,
        jobNo: '',
        uuid: '',
        rejectCallBack: null,
        refuseState: true
      },
      opVerifyFrameDialog: { // 审核通过
        visible: false,
        job: null,
        jobList: [],
        submitCallBack: null
      }
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    isNew() {
      return this.action === 'add' || this.action === 'copy'
    },
    isEditing() {
      return this.action !== 'look'
    },
    isOrder() { // 下单
      return this.viewSource === 'fbaOrder'
    },
    isVerify() { // 审核
      return this.viewSource === 'fbaVerify'
    },
    preVerifyStateIcon() {
      const verifyState = Number(this.currentRow.verifyState)
      const submitState = Number(this.currentRow.submitState)
      if (verifyState > 0) {
        switch (verifyState) {
          case 1:
            return this.isZh ? icon2 : iconEn2
          case 2:
            return this.isZh ? icon3 : iconEn3
          case 5:
            return this.isZh ? icon6 : iconEn6
          case 6:
            return this.isZh ? icon5 : iconEn5
        }
      } else {
        if (submitState === 1) {
          return this.isZh ? icon4 : iconEn4
        } else if (submitState === 2) {
          return this.isZh ? icon1 : iconEn1
        }
      }
      return ''
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isPretrialReviewFBA = Number(cache.config.get('PretrialReviewFBA')) === 1
  },
  methods: {
    // 公用方法，进入详情每个页签都会调用
    async onShow(action, rowData, selectedRow) {
      if (action === 'copy') {
        this.copyJobNum = selectedRow.copyNum
      }
      this.selectedRow = selectedRow
      this.action = action
      this.rowData = rowData
      this.$nextTick(() => {
        this.resetActiveTabName()
      })
      if (!selectedRow.uuid && action === 'add') {
        new FbaJob(selectedRow).fillDefaultValue().getData()
      }
      this.$nextTick(async() => {
        if (this.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.gridApi)
        }
        this.gridApi.clearFocusedCell()
        await this.onRowClicked({ data: selectedRow })
      })
    },
    async onRowClicked(event) {
      this.currentRow = null
      console.log('onRowClicked', event.data)
      this.currentRow = event.data
      if (this.currentRow.uuid) {
        this.setGridSelect(this.currentRow)
        this.loading = getLoading()
        await getFbaJob({ 'uuid': this.currentRow.uuid }).then(res => {
          this.currentRow = res.data
        }).finally(() => {
          this.loading.close()
        })
      }
      // if (!this.currentRow.goods) this.currentRow.goods = []
      // if (!this.currentRow.address) this.currentRow.address = this.initialRow()
      this.pendTabSet.clear()
      this.parentContext.modifiedData = {}
      this.$nextTick(() => {
        this.resetActiveTabName()
        this.handleTabClick()
      })
    },
    buildNewRow(selectedRow) {
      const initRow = this.initialRow()
      selectedRow = new FbaJob(initRow).fillDefaultValue().getData()
      console.log('buildNewRow selectedRow', selectedRow)
    },
    // 初始记录
    initialRow() {
      const newRow = {
        fba: true,
        ams: false,
        heating: false,
        comercialInspectation: false,
        customs: false,
        signMBL: false,
        signHBL: false,
        mblOnly: false,
        salePrice: false,
        bookingNo: '',
        customerId: '',
        sales: '',
        op: '',
        quotationNo: '',
        customerContact: '',
        salesDepartment: '',
        opDepartment: '',
        warehouseNo: '',
        contactTelephone: '',
        salesOffice: this.$store.getters.currentOffice.officeId,
        opOffice: this.$store.getters.currentOffice.officeId,
        contactFax: '',
        csr: '',
        dc: '',
        csrDepartment: '',
        csrOffice: '',
        containerLoadType: 'FCL',
        preAmazonWhTime: null,
        shippingType: 'SE',
        poNumber: '',
        chargingMethod: '1',
        packing: '',
        vatNo: '',
        serviceChannel: '',
        loadingPortCode: '',
        destinationDistribution: '0', // 默认卡车
        shipmentId: '',
        bubbleCountingRatio: 0.0,
        bubbleSplittingRatio: 0.0,
        cargoType: 'GC',
        taxRegisterCountry: '',
        domesticWarehouse: '',
        warehouseCode: '',
        remoteWarehouse: false,
        incoTerm: '',
        referenceId: '',
        customsMethodPol: '',
        electric: false,
        magnetic: false,
        powdery: false,
        liquid: false,
        taxRegisterAddress: '',
        preWarehousingTime: null,
        country: '',
        zipCode: '',
        customerRequire: '',
        customsMethodPod: '',
        eoriNo: '',
        taxCompany: '',
        quantityContract: 0.0,
        weightContract: 0.0,
        cubageContract: 0.0,
        pickupService: false,
        pickupTime: null,
        pickupDoor: '',
        doorMan: '',
        doorManTel: '',
        doorAddress: '',
        remarks: '',
        goods: [], // 箱货明细
        address: {
          // 发货人相关
          shipperEnterpriseName: '',
          shipperCountryCode: '',
          shipperCountryName: '',
          shipperProvinceCode: '',
          shipperProvinceName: '',
          shipperCityCode: '',
          shipperCityName: '',
          shipperZipCode: '',
          shipperFax: '',
          shipperContactName: '',
          shipperContactTel: '',
          shipperContactEmail: '',
          shipperAddress1: '',
          shipperAddress2: '',
          shipperAddress3: '',
          shipperEoriNo: '',
          shipperVatNo: '',
          shipperVatNoType: '',
          // 收货人相关
          consigneeEnterpriseName: '',
          consigneeCountryCode: '',
          consigneeCountryName: '',
          consigneeProvinceCode: '',
          consigneeProvinceName: '',
          consigneeCityCode: '',
          consigneeCityName: '',
          consigneeZipCode: '',
          consigneeFax: '',
          consigneeContactName: '',
          consigneeContactTel: '',
          consigneeContactEmail: '',
          consigneeAddress1: '',
          consigneeAddress2: '',
          consigneeAddress3: '',
          consigneeEoriNo: '',
          consigneeVatNo: '',
          consigneeVatNoType: '',
          // 通知人相关
          notifyEnterpriseName: '',
          notifyCountryCode: '',
          notifyCountryName: '',
          notifyProvinceCode: '',
          notifyProvinceName: '',
          notifyCityCode: '',
          notifyCityName: '',
          notifyZipCode: '',
          notifyFax: '',
          notifyContactName: '',
          notifyContactTel: '',
          notifyContactEmail: '',
          notifyAddress1: '',
          notifyAddress2: '',
          notifyAddress3: '',
          notifyEoriNo: '',
          notifyVatNo: '',
          notifyVatNoType: ''
        }
      }
      console.log('newRow', this.form)
      return newRow
    },
    initAddress() {
      const newAddress = {
        // 发货人相关
        shipperEnterpriseName: '',
        shipperCountryCode: '',
        shipperCountryName: '',
        shipperProvinceCode: '',
        shipperProvinceName: '',
        shipperCityCode: '',
        shipperCityName: '',
        shipperZipCode: '',
        shipperFax: '',
        shipperContactName: '',
        shipperContactTel: '',
        shipperContactEmail: '',
        shipperAddress1: '',
        shipperAddress2: '',
        shipperAddress3: '',
        shipperEoriNo: '',
        shipperVatNo: '',
        shipperVatNoType: '',
        // 收货人相关
        consigneeEnterpriseName: '',
        consigneeCountryCode: '',
        consigneeCountryName: '',
        consigneeProvinceCode: '',
        consigneeProvinceName: '',
        consigneeCityCode: '',
        consigneeCityName: '',
        consigneeZipCode: '',
        consigneeFax: '',
        consigneeContactName: '',
        consigneeContactTel: '',
        consigneeContactEmail: '',
        consigneeAddress1: '',
        consigneeAddress2: '',
        consigneeAddress3: '',
        consigneeEoriNo: '',
        consigneeVatNo: '',
        consigneeVatNoType: '',
        // 通知人相关
        notifyEnterpriseName: '',
        notifyCountryCode: '',
        notifyCountryName: '',
        notifyProvinceCode: '',
        notifyProvinceName: '',
        notifyCityCode: '',
        notifyCityName: '',
        notifyZipCode: '',
        notifyFax: '',
        notifyContactName: '',
        notifyContactTel: '',
        notifyContactEmail: '',
        notifyAddress1: '',
        notifyAddress2: '',
        notifyAddress3: '',
        notifyEoriNo: '',
        notifyVatNo: '',
        notifyVatNoType: ''
      }
      return newAddress
    },
    resetActiveTabName() {
      if (this.isNew) {
        this.activeTabName = this.getDefaultActiveName()
      } else {
        const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
        if (activePanes && activePanes.length === 0) {
          this.activeTabName = this.getDefaultActiveName()
        }
      }
    },
    getDefaultActiveName() {
      const firstPane = this.$refs['tabs'].panes[0]
      return firstPane ? firstPane.name : ''
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.getRenderedNodes()
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        const itemKey = item.data.uuid
        const rowKey = row.uuid
        if (itemKey === rowKey || !itemKey) {
          item.setSelected(true)
          item.setData(item.data)
          this.gridApi.ensureIndexVisible(item.rowIndex)
          break
        }
      }
    },
    // 返回
    goBack() {
      this.activeTabName = 'tabBaseInfo'
      this.action = ''
      this.$emit('back', true)
    },
    // 编辑
    editHandler(row) {
      if (!row) {
        row = this.currentRow
      }
      let checkMsg = ''
      if (row.submitState && row.submitState === FbaJobConstants.SUBMIT_STATE_SUBMITTED.code) {
        if (row.verifyState === FbaJobConstants.VERIFY_STATE_PENDING.code) {
          checkMsg = FbaJobConstants.VERIFY_STATE_PENDING.chineseName
        } else if (row.verifyState === FbaJobConstants.VERIFY_STATE_APPROVED.code) {
          checkMsg = FbaJobConstants.VERIFY_STATE_APPROVED.chineseName
        } else if (row.verifyState === FbaJobConstants.VERIFY_STATE_REVIEWED.code) {
          checkMsg = FbaJobConstants.VERIFY_STATE_REVIEWED.chineseName
        }
      }
      if (checkMsg) {
        this.$message.warning(checkMsg + '的业务不能编辑')
        return
      }
      this.onShow('edit', this.rowData, row)
    },
    // 取消编辑
    cancelEdit() {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        if (this.currentRow.uuid) { // 编辑取消还是详情
          this.onShow('look', this.rowData, this.currentRow)
        } else {
          this.goBack() // 新增取消返回列表
        }
      }).catch(() => { })
    },
    // 保存
    async saveHandler() {
      this.loading = getLoading4Cxt(this)
      const body = {}
      try {
        const pendTabSet = [...this.pendTabSet]
        for (const item of pendTabSet) {
          let tabData = null
          // 各页签的保存数据
          const getSubmitData = this.$refs[item].getSubmitData
          if (getSubmitData && typeof getSubmitData === 'function') {
            /* 获取各页签需要保存的数据 */
            const result = this.$refs[item].getSubmitData()
            if (result instanceof Promise) {
              tabData = await result
            } else {
              tabData = result
            }
          }
          if (!tabData) continue
          // this.$logger.log(item, tabData)
          Object.assign(body, tabData)
        }
      } catch (err) {
        if (err instanceof TabError) {
          this.loading.close()
          this.activeTabName = err.tabName
          if (err.message) {
            this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
          }
          return
        }
        throw err
      }
      // CARGO-17771 新增业务时，当费用单位为计费重量单位时，修改基本页签体积，点击保存，报空指针错误。
      if (body.charges && body.charges.length > 0) {
        for (const charge of body.charges) {
          if (!charge.uuid) continue
          if (charge.uuid.startsWith('addTabSelling__') || charge.uuid.startsWith('addTabCost__')) {
            charge.uuid = ''
          }
        }
      }
      if (this.isOrder) {
        if (this.loading) this.loading.close()
        await this.$confirm('保存是否提交预审状态', this.$t('common.tips.confirm'), {
          confirmButtonText: this.$t('common.btn.yes'),
          cancelButtonText: this.$t('common.btn.no'),
          closeOnClickModal: false,
          showClose: false,
          type: 'info'
        }).then(() => {
          body.submitState = 2
          body.submitBy = this.$store.getters.userId
          body.submitDate = new Date()
        }).catch(() => {
          body.submitState = 1
        })
      }
      // 校验
      console.log('save', body)
      this.loading = getLoading()
      await saveFbaJob(body).then(res => {
        const result = res.data
        if (result) {
          for (const key in result) {
            this.currentRow[key] = result[key]
          }
        }
        if (this.isNew) { // 新增成功后将当前数据加到集合中
          this.rowData = [...this.rowData, this.currentRow]
        }
        if (this.copyJobNum <= 1) {
          this.$message.success(this.$t('Message.SavedSuccessfully'))
          this.onShow('look', this.rowData, this.currentRow)
        }
      }).finally(() => {
        if (this.copyJobNum <= 1) {
          this.loading.close()
        }
      })
      if (this.copyJobNum > 1) {
        body.copyNum = this.copyJobNum - 1
        this.saveCopyJobHandle(body)
        this.copyJobNum = 0
      }
    },
    saveCopyJobHandle(body) {
      saveCopyJob(body).then(res => {
        const newJobList = res.data
        if (newJobList && newJobList.length > 0) {
          this.rowData = [...this.rowData, ...newJobList]
        }
        this.$message.success(this.$t('Message.SavedSuccessfully'))
        this.onShow('look', this.rowData, this.currentRow)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 保存默认值
    saveDefaultVal() {

    },
    // tab页签切换
    handleTabClick() {
      const oldSize = this.pendTabSet.size
      this.pendTabSet.add(this.activeTabName)
      const isRefresh = this.pendTabSet.size > oldSize
      this.$nextTick(() => {
        if (this.activeTabName === 'tabFileHistory') this.currentRow.className = 'FbaJob'
        this.$refs[this.activeTabName].onShow(this.currentRow, isRefresh)
      })
    },
    // 刷新
    onRefresh() {
      const result = this.currentRow
      if (result) {
        for (const key in result) {
          if (typeof result[key] === 'object') {
            result[key] = ''
          }
        }
        this.onRowClicked({ data: result })
      }
    },
    // 复制
    toCopy() {
      this.$emit('copy', this.currentRow)
    },
    // 暂不提交
    toNotSubmit() {
      this.$emit('notSubmit', this.currentRow)
    },
    // 提交
    toSubmit() {
      this.$emit('submit', this.currentRow)
    },
    // 打印
    onPrint() {
      this.$nextTick(async() => {
        // 每个页签的参数
        const params = await this.$refs[this.activeTabName].getPrintData() || null
        if (!params) return
        // 公共参数
        if (!Object.prototype.hasOwnProperty.call(params, 'jobuuid') || !params.jobuuid) {
          params.jobuuid = this.currentRow.uuid
        }
        if (!Object.prototype.hasOwnProperty.call(params, 'JOB_UUID') || !params.JOB_UUID) {
          params.JOB_UUID = this.currentRow.uuid
        }
        console.log('---params--', params)
        this.templateSelectorDialog.ctx = Object.prototype.hasOwnProperty.call(params, 'ctx') ? params.ctx : null
        if (Object.prototype.hasOwnProperty(params, 'ctx')) delete params.ctx
        this.templateSelectorDialog.category = params.category
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        await this.onPrintCallback(params)
        this.templateSelectorDialog.visible = true
      })
    },
    // 组装打印回调函数 优先取 params 里面的回调，再取页签中的回调，这样修改是为了满足国外账单的特殊情况
    onPrintCallback(params) {
      if (Object.prototype.hasOwnProperty.call(params, 'prePrintCallback')) {
        this.prePrintCallback = params.prePrintCallback
        delete params.prePrintCallback
      } else {
        this.prePrintCallback = this.$refs[this.activeTabName].prePrintCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'printedCallback')) {
        this.printedCallback = params.printedCallback
        delete params.printedCallback
      } else {
        this.printedCallback = this.$refs[this.activeTabName].printedCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'v2CheckCallback')) {
        this.v2CheckCallback = params.v2CheckCallback
        delete params.v2CheckCallback
      } else {
        this.v2CheckCallback = this.$refs[this.activeTabName].v2CheckCallback || null
      }
    },
    // 审核通过
    toApproved() {
      const jobArr = []
      const fbaJob = this.currentRow
      if (fbaJob.jobState !== -1 || fbaJob.verifyState === 1 || fbaJob.verifyState === 2) {
        jobArr.push(fbaJob.jobNo)
      }
      if (this.isPretrialReviewFBA && (fbaJob.verifyState === 5 || fbaJob.verifyState === 6)) {
        jobArr.push(fbaJob.jobNo)
      }
      if (jobArr.length > 0) {
        const str = this.isPretrialReviewFBA ? `${this.$t('Message.Approved')}/${this.$t('CargoMsg.Cargo_Denied')}/${this.$t('SeaExport.VerifyReviewThrough')}/${this.$t('SeaExport.ReviewRejectedBusinessNumber')}` : `${this.$t('Message.Approved')}/${this.$t('SeaExport.RejectedBusinessNumber')}`
        const h = this.$createElement
        const content = h('div', null, [
          h('p', { style: 'overflow-wrap: break-word;' }, jobArr.join(','))
        ])
        this.$alert(content, str)
        return
      }

      this.opVerifyFrameDialog.batchPassAudit = jobArr.length > 1
      this.opVerifyFrameDialog.job = fbaJob
      this.opVerifyFrameDialog.jobList = [fbaJob]
      this.opVerifyFrameDialog.submitCallBack = this.batchAudit
      this.opVerifyFrameDialog.visible = true
    },
    // 审核通过
    batchAudit(result) {
      if (result) {
        const objList = deepClone(this.opVerifyFrameDialog.jobList)
        for (const element of objList) {
          Object.assign(element, result)
          element.jobState = 0
          element.verifyState = 1
        }
        result = objList
      }
      this.loading = getLoading4Cxt()
      approved(result, this.$store.getters.currentOfficeId).then(res => this.approvedResultHandler(res)).finally(() => {
        this.loading.close()
      })
    },
    approvedResultHandler(res) {
      this.$message.success('审核成功！')
      this.onRefresh()
    },
    // 审核拒绝
    toRefuse() {
      this.rejectWindow.jobNo = this.currentRow.jobNo
      this.rejectWindow.uuid = this.currentRow.uuid
      this.rejectWindow.rejectCallBack = this.rejectCallBackHandler
      this.rejectWindow.visible = true
    },
    rejectCallBackHandler(remark) {
      this.loading = getLoading4Cxt()
      updNotSubmitOrSubmit({ type: 'FBA_REFUSE', keys: [this.rejectWindow.uuid], verifyRefuseReason: remark }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_Success'))
        this.onRefresh()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 复核通过
    toReApproved() {
      const jobNos = []
      if (this.currentRow.verifyState !== 1) {
        /* 有一个状态不是待审核就改为true 同时缓存他的委托单号*/
        jobNos.push(this.currentRow.bookingNo)
      }
      if (jobNos.length > 0) {
        const h = this.$createElement
        const content = h('div', null, [
          h('p', { style: 'overflow-wrap: break-word;' }, jobNos.join(','))
        ])
        this.$alert(content, this.$t('SeaExport.UnreviewedBusinessNumber2'))
        return
      }
      this.loading = getLoading4Cxt()
      updNotSubmitOrSubmit({ type: 'FBA_TO_REVIEW_ADOPT', keys: [this.currentRow.uuid] }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_Success'))
        this.onRefresh()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 复核拒绝
    toReRefuse() {
      this.rejectWindow.jobNo = this.currentRow.jobNo
      this.rejectWindow.uuid = this.currentRow.uuid
      this.rejectWindow.rejectCallBack = this.rejectsCallBackHandler
      this.rejectWindow.visible = true
    },
    rejectsCallBackHandler(remark) {
      this.loading = getLoading4Cxt()
      updNotSubmitOrSubmit({ type: 'FBA_TO_REVIEW_REFUSE', keys: [this.rejectWindow.uuid], verifyRefuseReason: remark }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_Success'))
        this.onRefresh()
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
</style>
